module.exports = __webpack_public_path__ + "img/Square.7881595f.svg";